<template>
  <div>
    <el-card>

      <el-form ref="addFormRef" :model="addForm" :rules="addFormRules" label-width="100px">
        <el-form-item label="客户编号" prop="guest_bianhao">
          <el-input v-model="addForm.guest_bianhao" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="客户姓名" prop="guest_name">
          <el-input v-model="addForm.guest_name"></el-input>
        </el-form-item>
        <el-form-item label="联系手机号" prop="guest_mob">
          <el-input v-model="addForm.guest_mob" max="11" min="10" :disabled="diaoyongType === 2 "></el-input>
        </el-form-item>
        <el-form-item label="联系地址" prop="guest_addr">
          <el-input v-model="addForm.guest_addr" max="11" min="10"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="guest_sfz_bianhao">
          <el-input v-model="addForm.guest_sfz_bianhao" max="11" min="10"></el-input>
        </el-form-item>
        <!-- <el-form-item label="客户等级" prop="guest_level">
          <el-select v-model="addForm.guest_level" placeholder="请选择客户等级">
            <el-option v-for="item in guest_options" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="客户心理价位" prop="guest_price_want">
          <el-input v-model="addForm.guest_price_want" max="11" min="10"></el-input>
        </el-form-item>
        <el-form-item label="客户意向" prop="guest_yixiang" v-if="false">
          <el-input v-model="addForm.guest_yixiang" max="11" min="10"></el-input>
        </el-form-item>
        
        <el-form-item label="客户备注" prop="guest_memo"  v-if="false">
          <el-input v-model="addForm.guest_memo" max="11" min="10"></el-input>
        </el-form-item>

        <el-form-item label="客户来源" prop="guest_laiyuan">
          <el-select v-model="addForm.guest_laiyuan" placeholder="请选择客户来源">
            <el-option v-for="item in guestLy_options" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-card style="background-color: #eee;">
       
          会员账户: {{ addForm.guest_yue }} |
          保养卡账户: {{ addForm.guest_accout_baoyang }} |
          机油卡账户: {{ addForm.guest_accout_jiyou }} |
          洗车卡账户: {{ addForm.guest_accout_xiche }} |
          成为会员时间: {{ addForm.guest_huiyuan_time }}
      </el-card>
      </el-form>

      <div style="text-align: center;" v-if="diaoyongType === 1">
        <el-button @click="quxiao">取 消</el-button>
        <el-button type="primary" @click="add">确 定</el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
import cheXingSelect from '../cheXing_select.vue'
import { checkMobileTest, checkSfzId } from '../config/validator';
export default {

  // components: {
  //   cheXingSelect: cheXingSelect
  // },
  props: ['guestMob', 'diaoyongType', 'caozuoType', 'editUid'], // diaoyongType 1 正常的界面管理调用 2 开单调用 editUid 如果有值，说明是修改
  data() {
    return {
      
      addForm: {
        C_type: 'guest',
        guest_shang_uid: 0,
        guest_bianhao: '',
        guest_name: '',
        guest_mob: '',
        guest_addr: '',
        guest_sfz_bianhao: '',
        guest_level: '',
        guest_price_want: '',
        guest_yixiang: '',
        guest_memo: '',
        guest_laiyuan: '',
        uid: 0,
        type: 0
      },
      guestLy_options: [
      {
          value: 8,
          label: '会员'
        },
      {
          value: 1,
          label: '抖音'
        },
        {
          value: 2,
          label: '美团'
        },
        {
          value: 3,
          label: '自然到店'
        },
        {
          value: 4,
          label: '邀约'
        },
        {
          value: 5,
          label: '转介绍'
        },
        {
          value: 6,
          label: '领券'
        },
        {
          value: 7,
          label: '其他'
        }
      ],
      guest_options: [
        {
          value: 1,
          label: '初级客户'
        },
        {
          value: 2,
          label: '中级客户'
        },
        {
          value: 3,
          label: '高级客户'
        }
      ],
      addFormRules: {
        guest_name: [
          { required: true, message: '请输入客户名称', trigger: 'blur' },
          { min: 2, max: 20, message: '必须2到20位字符 ', trigger: 'blur' }
        ],
        guest_mob: [
          {
            validator: checkMobileTest.bind(
              this.addForm && this.addForm.guest_mob
            )
          }
        ]
        // guest_sfz_bianhao: [
        //   {
        //     validator: checkSfzId.bind(
        //       this.addForm && this.addForm.guest_sfz_bianhao
        //     )
        //   }
        // ]
      }

    }
  },
  created() {
    if (this.guestMob === undefined) this.addForm.guest_mob = ''
    else this.addForm.guest_mob = this.guestMob
    if (this.caozuoType === 1) this.getBianhao_guest_add() // 说明是添加
    if (this.caozuoType === 2) this.Info(this.editUid)
    // this.datekey = Date.now()
  },

  methods: {
    quxiao() {
      this.$emit('closeGuest')
    },
    getCarTypeSelectedUid(typeId) {
      //  console.log(880, typeId)
      this.addForm.chexing_uid = typeId
    },
    async getBianhao_guest_add() {
      const { data: res } = await this.$http.get('get_api', {
        params: { C_type: 'get_bianhao', C_table_type: 3 }
      });
      // console.log(JSON.parse(res.data)[0].bianhao_s);
      this.addForm.guest_bianhao = JSON.parse(res.data)[0].bianhao_l;
    },
    async Info(uid) {
      const { data: res } = await this.$http.get('get_api', {
        params: { C_table_name: 'guest_info', uid: uid, C_type: 'get_info' }
      });
      if (JSON.parse(res.data)[0].status !== 200) {
         this.$message.error('读取失败');
         return
      }
      this.addForm = JSON.parse(res.data)[0].data[0];
    },
    nullToString(data) {
      if (data === undefined) {
          return ''
      } else {
        return data
      }
    },
    add(callback) {
      var errFlag = 0 
      this.$refs.addFormRef.validate(async valid => {
        if (!valid) {
            errFlag = 1 
          var data = {}
          if (this.diaoyongType === 2) callback(errFlag, data)
           return 1;
        }
        this.add_isDisable = true
        setTimeout(() => {
          this.add_isDisable = false // 点击一次时隔两秒后才能再次点击
        }, 2000)
        var Info = {
          C_type: 'guest',
          guest_shang_uid: 0,
          guest_bianhao: this.nullToString(this.addForm.guest_bianhao),
          guest_name: this.nullToString(this.addForm.guest_name),
          guest_mob: this.nullToString(this.addForm.guest_mob),
          guest_addr: this.nullToString(this.addForm.guest_addr),
          guest_sfz_bianhao: this.nullToString(this.addForm.guest_sfz_bianhao),
          guest_level: this.nullToString(this.addForm.guest_level),
          guest_price_want: this.nullToString(this.addForm.guest_price_want),
          guest_yixiang: this.nullToString(this.addForm.guest_yixiang),
          guest_memo: this.nullToString(this.addForm.guest_memo),
          guest_laiyuan: this.nullToString(this.addForm.guest_laiyuan),
          guest_huiyuan_level: this.nullToString(this.addForm.guest_huiyuan_level), // 以便传递到下一个页面 ，此项不保存到数据库
          uid: this.editUid,
          type: this.caozuoType
        }
        console.log('info', Info, this.addForm)
        if (this.addForm.guest_bianhao.length === 0) {
          this.$message.error('无编号，请重新递交');
           errFlag = 1
           callback(errFlag, Info) // 返回错误 uid 为 0
           return
        }
        const { data: res } = await this.$http.post('api', Info);
        // console.log(90, JSON.parse(res.data)[0].status)
        if (JSON.parse(res.data)[0].status === 202) {
          this.$message.success('客户重复！');
          errFlag = 1
          callback(errFlag, Info) // 返回错误 uid 为 0
          // this.$emit('getErr', 0) // 管理页面调用
          return
        }
        if (JSON.parse(res.data)[0].status !== 200) {
          this.$message.success('添加出错');
           errFlag = 1
           callback(errFlag, Info) // 返回错误 uid 为 0
           return
        }
        if (JSON.parse(res.data)[0].status === 200) this.$message.success('操作成功！');
        if (this.caozuoType === 1) Info.uid = JSON.parse(res.data)[0].guest_uid // 反写uid
        console.log('客户添加返回信息', Info)
        if (this.diaoyongType === 1) this.$emit('getGuestNewUid', Info) // 管理页面调用
        if (this.diaoyongType === 2) callback(errFlag, Info) // 开单过程调用
      });
    },
    async test_input() {
            if (this.kucunAddData.length === 0) {
                this.$message.error('请录入商品及数量后再行递交！')
                return 0
            }
            const comfirmResult = await this.$confirm(
                '确定商品出库, 是否继续?',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).catch(err => err);
            if (comfirmResult === 'cancel') return 0 
            else return 1
        },
    resetForm() {
      this.$refs.addFormRef.resetFields();
    }
  }
}
</script>../cheXing_selectB.vue
